import { createContext } from 'preact';

const SelectContext = createContext();

export default SelectContext;
